module.exports = __webpack_public_path__ + "static/media/ASA.d2aeffc5.png";